import { useState } from 'react';
import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';

import GlobalHeader from '../../components/GlobalHeader';
import PaddedContainer from '../../components/PaddedContainer ';
import { SLPInfluencersHero } from './SLPInfluencersHero';
import SLPInfluencersWhy from './SLPInfluencersWhy';
import { SLPInfluencersHow } from './SLPInfluencersHow';
//import SLPInfluencersUserReview from './SLPInfluencersUserReview';
import BannerImage from '../../assets/banner.png';
import Button from '../components/Button';
import SLPInfluencersListPersonaBtn from './SLPInfluencersListPersonaBtn';
import SLPFooter from '../components/SLPFooter';

const ugcCreatorFaqs = [
  {
    q: 'Do I have to use AI to work with Saagas?',
    a: 'No. AI is one option. Many of our brand campaigns use traditional UGC — you film at home, deliver the videos, get paid. AI workflows are available when a brand specifically wants AI-generated content from your Persona, but you always choose whether to opt in.',
  },
  {
    q: 'How do I get paid?',
    a: 'You set your rate per campaign or per Persona-use. When a brand books you, payment is held in escrow and released once you approve the final content. Saagas handles 1099 forms, international payouts, and tax compliance — you get paid in your preferred currency.',
  },
  {
    q: 'What rights am I giving brands when I license my Persona?',
    a: 'Only what you approve, for the duration you approve. Each campaign spells out exactly which content can be made, on which platforms, for how long. Nothing goes live without your sign-off, and rights revert to you when the campaign ends.',
  },
  {
    q: 'What kinds of brands work with Saagas?',
    a: 'Growth-stage and scaled consumer apps, B2B SaaS brands, and DTC companies running paid TikTok and Meta. We vet every brand for safety, payment terms, and content alignment before they can reach out to creators.',
  },
  {
    q: 'How long does a typical campaign take?',
    a: 'From brief to delivered content: 5–10 business days for traditional UGC. You\'re never on the hook for more than a single review round.',
  },
  {
    q: 'Can I work with multiple brands at once?',
    a: 'Yes — provided campaigns don\'t conflict (e.g. competing brands in the same category over the same time window). You approve every brief, so you\'re always in control of overlap.',
  },
  {
    q: 'How do I get started?',
    a: 'Apply through "List Your Persona". We\'ll review fit (~2 business days), then onboard you with a quick KYC/payout setup and your first campaign briefs.',
  },
];

const InlineFAQ = ({ faqs }: { faqs: { q: string; a: string }[] }) => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return (
    <Box
      component="section"
      sx={{
        pt: { xs: '2.5rem', md: '4rem' },
        pb: { xs: '2rem', md: '3rem' },
        px: { xs: '1rem', md: '2rem' },
        maxWidth: '800px',
        mx: 'auto',
        width: '100%',
      }}
    >
      <Typography
        fontFamily="Inter"
        component="h2"
        sx={{
          fontWeight: 700,
          fontSize: { xs: '24px', md: '34px' },
          color: '#FFFFFF',
          textAlign: 'center',
          mb: 4,
        }}
      >
        Common questions.
      </Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        {faqs.map(({ q, a }, i) => (
          <Box key={q} sx={{ border: '1px solid rgba(255,255,255,0.1)', borderRadius: '10px', overflow: 'hidden' }}>
            <Box
              component="button"
              onClick={() => setOpenIndex(openIndex === i ? null : i)}
              sx={{
                width: '100%',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                textAlign: 'left',
                px: 2.5,
                py: 2,
                background: 'transparent',
                border: 'none',
                cursor: 'pointer',
                color: '#FFFFFF',
                fontFamily: 'Inter',
                fontWeight: 500,
                fontSize: { xs: '14px', md: '15px' },
                '&:hover': { background: 'rgba(255,255,255,0.04)' },
              }}
            >
              <span>{q}</span>
              <Box
                component="span"
                sx={{
                  ml: 2,
                  flexShrink: 0,
                  transition: 'transform 0.2s',
                  transform: openIndex === i ? 'rotate(180deg)' : 'rotate(0deg)',
                  color: '#808080',
                  fontSize: '18px',
                }}
              >
                ▾
              </Box>
            </Box>
            {openIndex === i && (
              <Box sx={{ px: 2.5, pb: 2.5, background: 'rgba(255,255,255,0.03)' }}>
                <Typography fontFamily="Inter" sx={{ fontSize: '14px', color: '#C0C0C0', lineHeight: '160%' }}>
                  {a}
                </Typography>
              </Box>
            )}
          </Box>
        ))}
      </Box>
    </Box>
  );
};

const SLPInfluencers = () => {
  const theme = useTheme();
  const isMdOrBelow = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <div className="overflow-hidden bg-green cursor-default">
      <GlobalHeader />
      <PaddedContainer>
        <SLPInfluencersHero />
      </PaddedContainer>
      <PaddedContainer>
        <SLPInfluencersWhy />
      </PaddedContainer>
      <Box id="slp-influencers-how">
        <PaddedContainer>
          <Box 
          // sx={{ marginBottom: {xs:0,sm:"0px",md:"100px",lg:"100px"} }}
          >
            <SLPInfluencersHow />
          </Box>
        </PaddedContainer>
      </Box>

      {/*<PaddedContainer bgColor="linear-gradient(195.36deg, rgba(16, 166, 202, 0.2) -110.46%, rgba(86, 20, 110, 0.2) 100%)">
        <Box
          className="max-w-[1256px] m-auto relative mt-[40px] md:mt-[80px]"
        >
          <SLPInfluencersUserReview />
        </Box>
      </PaddedContainer> */}
      <PaddedContainer>
        <Box
          sx={{
            overflow: 'hidden',
            width: '100%',
            height: {
              xs: '507px',
              md: '507px',
              lg: '422px'
            },
            backgroundImage: `url(${BannerImage})`,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            
          }}
        >
          <Box sx={{ textAlign: 'center', mt: '3.75rem' }}>
            <Typography
              fontFamily="Inter"
              sx={{
                fontFamily: 'Inter',
                fontWeight: 700,
                fontSize: '40px',
                lineHeight: '100%',
                letterSpacing: '0px',
                textAlign: 'center',
                verticalAlign: 'middle',
                color: '#FFFFFF'
              }}
            >
              Join UGC Creators and Brands
            </Typography>

            <Typography
              fontFamily="Inter"
              sx={{
                fontFamily: 'Inter',
                fontWeight: 400,
                fontSize: '24px',
                lineHeight: '100%',
                letterSpacing: '0px',
                textAlign: 'center',
                verticalAlign: 'middle',
                color: '#FFFFFFCC',
                mt: 2
              }}
            >
              who trust us to manage their <br/>UGC licensing needs
            </Typography>

            <Button
              as="a"
              href="https://t.co/401XPwdXQx"
              target="_blank"
              rel="noreferrer"
              variant="primary"
              style={{
                border: '1px solid #FAFAFA',
                backgroundColor: 'transparent',
                width: '206px',
                maxHeight: '60px',
                borderRadius: '30px',
                padding: '18px 16px',
                color: '#FAFAFA',
                fontWeight: 700,
                fontSize: '20px',
                textAlign: 'center',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                textDecoration: 'none',
                margin: '2rem auto 0'
              }}
            >
              Join our discord
            </Button>
          </Box>
        </Box>
      </PaddedContainer>

      <PaddedContainer>
        <InlineFAQ faqs={ugcCreatorFaqs} />
      </PaddedContainer>

      <PaddedContainer>
        <Box sx={{ textAlign: 'center', mt: 5, pb: { xs: '2rem', md: '0', lg: '4rem' }, pl: { sm: '16px' }, pr: { sm: '16px' } }}>
          <Box sx={{ pl: { xs: '16px' }, pr: { xs: '16px' }, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <Typography
              fontFamily="Inter"
              component="h3"
              variant="h3"
              sx={{
                fontFamily: 'Inter',
                fontWeight: 700,
                fontSize: { xs: '24px', md: '40px' },
                lineHeight: '100%',
                letterSpacing: '0px',
                textAlign: 'center',
                verticalAlign: 'middle',
                color: '#FFFFFF'
              }}
            >
              Express Yourself
            </Typography>
            <Typography
              component="p"
              fontFamily="Inter"
              sx={{
                mt: 2,
                fontFamily: 'Inter',
                fontWeight: { xs: 500, md: 400 },
                fontSize: { xs: '16px', md: '24px' },
                lineHeight: '122%',
                letterSpacing: '0px',
                textAlign: 'center',
                verticalAlign: 'middle',
                color: '#FFFFFFCC',
                
              }}
            >
              While upholding the value of human artistry in the age of AI
            </Typography>
            <Box sx={{ width: { xs: '164px', md: '200px' }, mt: { xs: '4px', } }}>
              <SLPInfluencersListPersonaBtn
                maxWidth={isMdOrBelow ? '131px' : '200px'}
                maxHeight={isMdOrBelow ? '49px' : '52px'}
                fontSize={isMdOrBelow ? '14px' : '16px'}
                padding={isMdOrBelow ? '8px 15px' : '16px 32px'}
                marginTop={{xs:"40px",sm:"40px"}}
              />
            </Box>
          </Box>
        </Box>
      </PaddedContainer>
      <PaddedContainer>
        <SLPFooter />
      </PaddedContainer>
    </div>
  );
};

export default SLPInfluencers;
